<template>
    <div class="c-box p-5">
        <div class="c-box__content">
            Please wait while we are logging you in <br>
            {{error_text}}
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: "Logout"
    },

    mounted() {
        this.login_as_support();
    },

    props: {
    	company_id: {
    		type: Number,
            default: 0,
        },
		sso_token: {
    		type: String,
            default: '',
        },
    },

    data: function() {
        return {
            login_in_progress: false,
			error_text: '',
		};
    },

    watch: {},

    computed: {},

    methods: {
		login_as_support: function() {
            this.login_in_progress = true;

            let payload = {
            	company_id: parseInt(this.company_id),
                sso_token: this.sso_token.trim(),
            };

            this.$store.dispatch("user/LoginAsSupport", payload).then(
                (success_data) => {
                    this.login_in_progress = false;
                    console.log('xxx');
					window.location.href = this.$router.resolve({ name: "account.information" }).href;
				},
                (error_data) => {
                	this.error_text = error_data;
                }
            );
        },
    }
};
</script>
